import {EditorSelection} from "@codemirror/state";

import {canInsertTopLevelBlockSelectable, wholeLineWithOptionalNewline} from "./topLevel.js";
import {blank, trimmedBlockRange, trimToNewLines} from './trim.js';
import {selectedTypesOnlyAllowed, selectedText} from "../state.js";
import {preprocessHeadersAndRows} from "./table/preprocess.js";
import {parseTableBlueprint} from './table/blueprint.js';
import {MarkdownTable} from './table/MarkdownTable.js';

export function headersFromArray(array) {
  array.forEach(doesntContainPipe);
  return index => {
    if (array.hasOwnProperty(index)) {
      return array[index];
    }
    throw `Failed to get header of index #${index} for array`;
  };
}

export function canAddTable({state}) {
  return wholeLineWithOptionalNewline(state) && canInsertTopLevelBlockSelectable({state}) && selectedTypesOnlyAllowed(state, [
    'Paragraph', 'Emphasis', 'StrongEmphasis', 'EmphasisMark',
    'InlineCode', 'CodeMark', 'Strikethrough', 'StrikethroughMark',
    'Keyboard', 'KeyboardKey', 'HTMLTag', 'Entity',
    'Link', 'Image', 'LinkMark', 'URL',
  ]);
}

export function addTable(headerByIndex, placeholder) {
  doesntContainPipe(placeholder);
  if (untrimmed(placeholder)) {
    throw "Placeholder contains untrimmed whitespace";
  }
  return ({state, dispatch}) => {
    if (!canAddTable({state})) {
      return;
    }
    const {table, selected} = markdownTable(state, placeholder, headerGen(headerByIndex));
    return dispatch({
      ...insertTable(state, table, selected),
      userEvent: "input.table"
    });
  };
}

function untrimmed(string) {
  return string !== string.trim();
}

function doesntContainPipe(content) {
  if (content.indexOf("|") > -1) {
    throw "Improper markdown content";
  }
}

function insertTable(state, table, selected) {
  return changeByTrimmedBlock(state, ({from, to}) => {
    const markdown = table.markdown();
    const {offset, length} = table.firstCellSelected();
    const padding = topPadding(state, from);
    return {
      changes: {from, to, insert: padding + markdown},
      range: selected
        ? EditorSelection.range(from + padding.length + offset, from + padding.length + offset + length)
        : EditorSelection.cursor(from + padding.length + markdown.length)
    };
  });
}

function changeByTrimmedBlock(state, caller) {
  return state.changeByRange(range => caller(trimmedBlockRange(state, range)));
}

function topPadding(state, from) {
  return needsPadding(state, from) ? '\n' : '';
}

function needsPadding(state, from) {
  if (from === 0) {
    return false;
  }
  const line = state.doc.lineAt(from - 1);
  return !blank(state.sliceDoc(line.from, line.to));
}

function markdownTable(state, firstCell, nextHeader) {
  const {headers, rows} = preprocessHeadersAndRows(parseTableBlueprint(trimToNewLines(selectedText(state))), nextHeader);
  if (rows.length === 0) {
    return {table: new MarkdownTable(headers, [[firstCell, '']]), selected: true};
  }
  return {table: new MarkdownTable(headers, rows), selected: false};
}

function headerGen(headerByIndex) {
  return (header, index) => {
    if (blank(header)) {
      const _header = headerByIndex(index);
      doesntContainPipe(_header);
      return _header;
    }
    return header;
  };
}
